import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Columns, Input, Select } from '@deseretbook/react-ui'

/**
 * A group of address fields. It is just a generic organization of inputs allowing
 * a user to enter an address. It should be used inside `Form` and `AddressFormManager`
 * components.
 */
const AddressFormFields = ({
  address,
  onChange,
  states,
  statesRequired,
  countries,
  isFetchingData,
}) => (
  <Fragment>
    <Columns isMobile>
      <Columns.Column>
        <Input
          type="text"
          name="firstname"
          label="First Name"
          value={address.firstname}
          onChange={onChange}
          required
          maxLength={30}
        />
      </Columns.Column>
      <Columns.Column>
        <Input
          type="text"
          name="lastname"
          label="Last Name"
          value={address.lastname}
          onChange={onChange}
          required
          maxLength={30}
        />
      </Columns.Column>
    </Columns>
    <Select
      name="countryId"
      label="Country"
      options={countries.map(country => ({ label: country.name, value: country.id }))}
      value={address.countryId}
      onChange={onChange}
      isLoading={isFetchingData}
      required
    />
    <Input
      type="text"
      name="address1"
      label="Street Address"
      value={address.address1}
      onChange={onChange}
      required
      maxLength={30}
    />
    <Input
      type="text"
      name="address2"
      label="Street Address (continued)"
      value={address.address2}
      onChange={onChange}
      maxLength={30}
    />

    <Columns isMobile>
      <Columns.Column>
        <Input
          type="text"
          name="city"
          label="City"
          value={address.city}
          onChange={onChange}
          required
          maxLength={30}
        />
      </Columns.Column>
      <Columns.Column>
        {
          states && states.length
            ? (
              <Select
                name="stateId"
                label="State"
                options={states.map(({ name, id }) => ({ label: name, value: id }))}
                value={address.stateId}
                onChange={onChange}
                required={statesRequired}
                isLoading={isFetchingData}
              />
            )
            : (
              <Input
                name="stateName"
                label="State"
                value={address.stateName}
                onChange={onChange}
                required={statesRequired}
                isLoading={isFetchingData}
                maxLength={30}
              />
            )
        }
      </Columns.Column>
    </Columns>
    <Columns isMobile>
      <Columns.Column>
        <Input
          type="text"
          name="zipcode"
          label="Postal Code"
          value={address.zipcode}
          onChange={onChange}
          required
          maxLength={10}
        />
      </Columns.Column>
      <Columns.Column>
        <Input
          type="tel"
          name="phone"
          label="Phone Number"
          value={address.phone}
          onChange={onChange}
          required
          maxLength={20}
        />
      </Columns.Column>
    </Columns>
  </Fragment>
)

AddressFormFields.propTypes = {
  // Address data
  address: PropTypes.object,
  // Callback for each input field.
  onChange: PropTypes.func,
  // Array of states.
  states: PropTypes.array,
  // If a state value is required for current country.
  statesRequired: PropTypes.bool,
  // Array of countries
  countries: PropTypes.array,
  // If data is being fetched.
  isFetchingData: PropTypes.bool,
}

AddressFormFields.defaultProps = {
  address: {},
  onChange: () => {},
  states: [],
  statesRequired: false,
  countries: [],
  isFetchingData: false,
}

export default AddressFormFields
